export * from './points-badge';
